export enum UserPreferencesConstants {
  TRICKS = "tricks",
  LINES = "lines",
  EDITS = "edits",
}